var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodCourt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10228_924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 29L11.6978 34.683C13.2085 35.546 14.9183 36 16.6582 36H30.8418C32.5817 36 34.2915 35.546 35.8022 34.683L45.75 29",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 27L11.5393 29.424C13.1482 30.4531 15.0181 31 16.9279 31H17.5M39.75 27L35.9607 29.424C34.3518 30.4531 32.4819 31 30.5721 31H24.5",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 36V47.5M32.75 36V47.5",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 41L11.6978 46.683C13.2085 47.546 14.9183 48 16.6582 48H30.8418C32.5817 48 34.2915 47.546 35.8022 46.683L45.75 41",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 0.5,
    width: 17,
    height: 15,
    rx: 2.5,
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7273 13L25 9L30 9.44444L27.7273 13Z",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 8C28.7762 8 29.0022 7.77575 28.9792 7.50057C28.8836 6.35618 28.4611 5.25935 27.757 4.34334C26.951 3.29477 25.821 2.54189 24.5429 2.20178C23.2649 1.86168 21.9102 1.95339 20.6896 2.46267C19.469 2.97195 18.4509 3.87025 17.7936 5.0179C17.1362 6.16555 16.8765 7.49824 17.0548 8.80874C17.233 10.1192 17.8393 11.3341 18.7793 12.2645C19.7193 13.1948 20.9404 13.7885 22.2527 13.9533C23.3991 14.0972 24.5589 13.9067 25.5944 13.4101C25.8434 13.2907 25.9224 12.9823 25.7827 12.7441L23.4417 8.75298C23.2462 8.41965 23.4865 8 23.873 8H28.5ZM23 11.5C23 11.7761 22.7762 12 22.5 12C22.2239 12 22 11.7761 22 11.5C22 11.2239 22.2239 11 22.5 11C22.7762 11 23 11.2239 23 11.5ZM20.5 11C20.7762 11 21 10.7761 21 10.5C21 10.2239 20.7762 10 20.5 10C20.2239 10 20 10.2239 20 10.5C20 10.7761 20.2239 11 20.5 11ZM21 8.5C21 8.77614 20.7762 9 20.5 9C20.2239 9 20 8.77614 20 8.5C20 8.22386 20.2239 8 20.5 8C20.7762 8 21 8.22386 21 8.5ZM19.5 7C19.7762 7 20 6.77614 20 6.5C20 6.22386 19.7762 6 19.5 6C19.2239 6 19 6.22386 19 6.5C19 6.77614 19.2239 7 19.5 7ZM22 6.5C22 6.77614 21.7762 7 21.5 7C21.2239 7 21 6.77614 21 6.5C21 6.22386 21.2239 6 21.5 6C21.7762 6 22 6.22386 22 6.5ZM21.5 5C21.7762 5 22 4.77614 22 4.5C22 4.22386 21.7762 4 21.5 4C21.2239 4 21 4.22386 21 4.5C21 4.77614 21.2239 5 21.5 5ZM24 5.5C24 5.77614 23.7762 6 23.5 6C23.2239 6 23 5.77614 23 5.5C23 5.22386 23.2239 5 23.5 5C23.7762 5 24 5.22386 24 5.5ZM25.5 6C25.7762 6 26 5.77614 26 5.5C26 5.22386 25.7762 5 25.5 5C25.2239 5 25 5.22386 25 5.5C25 5.77614 25.2239 6 25.5 6Z",
    fill: "#ECBE08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 33.5H20L19 27.5H23L22 33.5Z",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 33L21.5 24.5H23.5",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10228_924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 49,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodCourt);
export default __webpack_public_path__ + "static/media/FoodCourt.07830f4af69688f1a5c3ee97f6015f29.svg";
export { ForwardRef as ReactComponent };